import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

import Footer from "../../Layouts/Footer";
import Topbar from "../../Layouts/Topbar";
import Header from "../../Layouts/Header";
import { API } from "../../constants";

const Register = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePhoneChange = (phone) => {
    setForm((prev) => ({
      ...prev,
      phoneNumber: phone,
    }));
  };

  const togglePassword = () => setShowPassword((v) => !v);
  const togglePassword2 = () => setShowPassword2((v) => !v);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: "", text: "" });

    if (!form.firstName.trim()) {
      setMessage({ type: "danger", text: "First name is required." });
      return;
    }

    if (!form.lastName.trim()) {
      setMessage({ type: "danger", text: "Last name is required." });
      return;
    }

    if (!form.email.trim()) {
      setMessage({ type: "danger", text: "Email is required." });
      return;
    }

    if (!form.phoneNumber.trim()) {
      setMessage({ type: "danger", text: "Phone number is required." });
      return;
    }

    if (!form.password || !form.confirmPassword) {
      setMessage({ type: "danger", text: "Password fields cannot be empty." });
      return;
    }

    if (form.password !== form.confirmPassword) {
      setMessage({ type: "danger", text: "Passwords do not match." });
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(API.CUSTOMER_REGISTER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: form.firstName,
          lastName: form.lastName,
          email: form.email,
          phoneNumber: form.phoneNumber,
          password: form.password,
          confirmPassword: form.confirmPassword,
        }),
      });

      const data = await res.json();

      if (res.ok && data.status === true) {
        setMessage({
          type: "success",
          text:
            data.message || "Registration successful! Redirecting to login...",
        });

        setTimeout(() => navigate("/login"), 700);
      } else {
        setMessage({
          type: "danger",
          text: data.message || "Registration failed.",
        });
      }
    } catch (error) {
      console.error(error);

      setMessage({
        type: "danger",
        text: "Server error. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Header />

      <div className="login-reg-area">
        <Container>
          <div className="login-reg-area-inner">
            <ul className="list-unstyled d-flex gap-3 align-items-center">
              <li>
                <Button className="login-reg-link-btn" as={Link} to="/login">
                  Login
                </Button>
              </li>
            </ul>

            <Row className="gy-4 gx-5">
              <Col md={5} lg={6}>
                <div className="login-img">
                  <img src="assets/images/new-register.png" alt="Signup" />
                </div>
              </Col>

              <Col md={7} lg={6}>
                <div className="login-registration-form">
                  <div className="form-title">
                    <h3>Sign Up</h3>
                  </div>

                  <Form onSubmit={handleSubmit}>
                    {message.text && (
                      <Alert variant={message.type}>{message.text}</Alert>
                    )}

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="First Name *"
                        name="firstName"
                        value={form.firstName}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Last Name *"
                        name="lastName"
                        value={form.lastName}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Control
                        type="email"
                        placeholder="Email Here *"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3 phone-input-group">
                      <PhoneInput
                        defaultCountry="usa"
                        value={form.phoneNumber}
                        onChange={handlePhoneChange}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3 position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Password *"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        required
                      />

                      <i
                        className={`bi ${
                          showPassword ? "bi-eye" : "bi-eye-slash"
                        }`}
                        onClick={togglePassword}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: "10px",
                          top: "12px",
                        }}
                      ></i>
                    </Form.Group>

                    <Form.Group className="mb-3 position-relative">
                      <Form.Control
                        type={showPassword2 ? "text" : "password"}
                        placeholder="Confirm Password *"
                        name="confirmPassword"
                        value={form.confirmPassword}
                        onChange={handleChange}
                        required
                      />

                      <i
                        className={`bi ${
                          showPassword2 ? "bi-eye" : "bi-eye-slash"
                        }`}
                        onClick={togglePassword2}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: "10px",
                          top: "12px",
                        }}
                      ></i>
                    </Form.Group>

                    <Button
                      className="w-100 login-reg-sub"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Register"
                      )}
                    </Button>

                    <div className="member mt-3">
                      Already a member?{" "}
                      <Link to="/login">Click here to Login</Link>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Register;
